import { Checkmark } from '../icons/Checkmark'

export function Checkbox({ checked }: { checked: boolean }) {
  return (
    <div
      className={`min-w-5 min-h-5 rounded-sm [&>svg]:scale-75 transition-all ease-in-out  flex items-center justify-center ${
        checked ? 'bg-old-primary text-white' : 'bg-white border-[1px] border-gray-300'
      }`}
    >
      {checked && <Checkmark />}
    </div>
  )
}
